import { motion, useScroll, useTransform, useSpring } from "framer-motion";

/** Fixed vertical "water level" that recedes (drops) as the reader descends. */
export const WaterLevel = () => {
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });
  // Water level height = remaining water. Full at top, empty (dry) at the form.
  const fillHeight = useTransform(smooth, [0, 0.85], ["100%", "0%"]);
  const pct = useTransform(smooth, (v) => `${Math.round((1 - Math.min(v / 0.85, 1)) * 100)}`);
  const labelY = useTransform(smooth, [0, 0.85], ["0%", "92%"]);

  return (
    <div
      data-testid="water-level-indicator"
      aria-hidden="true"
      className="fixed right-3 sm:right-5 top-1/2 -translate-y-1/2 z-40 hidden sm:flex flex-col items-center h-[46vh]"
    >
      <div className="relative w-[3px] h-full rounded-full bg-white/10 overflow-hidden">
        <motion.div
          className="absolute top-0 left-0 w-full rounded-full bg-gradient-to-b from-erg-aqua via-erg-shallow to-erg-mid"
          style={{ height: fillHeight }}
        />
      </div>
      <motion.div
        className="absolute -right-1 translate-x-full flex items-center gap-1"
        style={{ top: labelY }}
      >
        <motion.span className="font-mono text-[9px] tracking-widest text-erg-aqua/70 tabular-nums">
          {pct}
        </motion.span>
        <span className="font-mono text-[9px] tracking-widest text-erg-aqua/40 whitespace-nowrap">
          % water
        </span>
      </motion.div>
    </div>
  );
};
